<template>
  <router-view />
</template>
<script>
export default {
  name: "App",
};
</script>
<style lang="stylus" scoped></style>



// WEBPACK FOOTER //
// src/App.vue